import { FILTER_TABS } from "../../constants";
import { MediaStatus } from "../../Media.types";
import React from "react";

interface Props {
  activeTab: MediaStatus | "ALL";
  onChange: (tab: MediaStatus | "ALL") => void;
  setPageState: React.Dispatch<React.SetStateAction<any>>; // <-- setter function
}

const MediaTabs: React.FC<Props> = ({ activeTab, onChange, setPageState }) => {
  return (
    <div className="flex gap-3 mb-6">
      {FILTER_TABS.map(({ value, label }) => (
        <button
          key={value}
          onClick={() => {
            onChange(value);

            setPageState((prev: { currentPage: number; totalPages: number | null }) => ({
              ...prev,
              currentPage: 0, 
            }));
          }}
          className={`px-4 py-2 rounded-full text-sm font-semibold ${
            activeTab === value
              ? "bg-orange-500 text-white"
              : "bg-white border text-gray-600 hover:bg-gray-100"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default MediaTabs;
